module.exports = __webpack_public_path__ + "media/images/vehicle-avatar-4e89c511e76523984e5ad00379fc97ae.svg";